import { useEffect, useState, useContext } from "react";
import {
    useLocation,
    useNavigate
  } from "react-router-dom";
import $ from 'jquery';
import UserContext from "../../contexts/UserContext";

const Logout = () => {
    const navigate = useNavigate();
    const {setUser} = useContext(UserContext);
    useEffect(()=>{
        $.ajax({
            type:"GET",
            url:process.env.REACT_APP_API_URL+"/logouts",
            xhrFields: {
                withCredentials: true  // Include cookies
              },
              crossDomain: true, 
             success : function(response){
                setUser(null);
                try{
                    if(localStorage.getItem('userSession')){
                        localStorage.removeItem("userSession");
                    }
                }catch(e){console.log(e)}
                navigate("/login")
              
            },
            error: function(err){
                console.log("error")
                console.log(err)
                navigate(0)
            }
        })
    },[])
}

export default Logout;